"use client";

import { useState, Suspense } from "react";
import { useRouter, useSearchParams } from "next/navigation";

function SiteLoginForm() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const searchParams = useSearchParams();
  const redirect = searchParams.get("redirect") || "/";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const res = await fetch("/api/site-auth", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password }),
    });

    if (res.ok) {
      router.push(redirect);
      router.refresh();
    } else {
      setError("Incorrect password");
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-sm p-8 space-y-4">
      <h1 className="text-2xl font-bold text-center">Site Access</h1>
      <p className="text-muted-foreground text-center text-sm">
        This site is password protected
      </p>

      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Enter password"
        className="w-full p-3 border rounded-lg bg-muted"
        autoFocus
      />

      {error && <p className="text-destructive text-sm text-center">{error}</p>}

      <button
        type="submit"
        disabled={loading || !password}
        className="w-full p-3 bg-primary text-primary-foreground rounded-lg disabled:opacity-50"
      >
        {loading ? "Verifying..." : "Enter"}
      </button>
    </form>
  );
}

export default function SiteLoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Suspense fallback={<div>Loading...</div>}>
        <SiteLoginForm />
      </Suspense>
    </div>
  );
}
